import { useCallback, useEffect, useState } from 'react';

import { useTranslation } from '@ciam/i18n';
import { useLoginStore } from '@features/shared';
import { useModal } from '@ciam/ui';
import { tenureCheckApi } from '../apis';

export const useTenureCheckEmail = (handleSetRootError: (message: string) => void) => {
  const { t } = useTranslation(['tenure-check']);
  const [isSendedEmail, setIsSendEmail] = useState(false);
  const { i18n } = useTranslation(['tenure-check']);
  const currentUser = useLoginStore((state) => state.currentUser);
  const { openModal } = useModal();

  const executeSendTenureCheckEmail = useCallback(async () => {
    const res = await tenureCheckApi.sendTenureCheckEmail({
      email: currentUser.email,
      lang: i18n.language,
    });

    if (res.errorCode === 0) {
      if (isSendedEmail)
        openModal({
          type: 'success',
          description: [t('form.resend-success')],
        });
    } else {
      handleSetRootError(res.errorDetails);
    }

    setIsSendEmail(true);
  }, [handleSetRootError, i18n.language, isSendedEmail, openModal, t, currentUser.email]);

  useEffect(() => {
    if (!isSendedEmail) executeSendTenureCheckEmail();
  }, [isSendedEmail, executeSendTenureCheckEmail]);

  return { executeSendTenureCheckEmail };
};
